import { styled } from 'stitches.config'

export const HeroRoot = styled('section', {
  backgroundColor: '$tertiary-200',
  paddingTop: '$5',
  paddingBottom: '$6',
  width: '100%',
  position: 'relative',
  paddingLeft: '0 !important',
  paddingRight: '0 !important',
})

export const HeroContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2.5rem',
  width: '100%',
  '@bp2': {
    paddingLeft: '$3',
    paddingRight: '$3',
  },
  '@bp3': {
    paddingLeft: '15.9vw',
    paddingRight: '15.9vw',
  },
})

export const HeroTitle = styled('h1', {
  color: '$primary-500',
  fontSize: '$h2',
  fontWeight: '$semiBold',
  textAlign: 'center',
  textWrap: 'pretty',
  paddingLeft: '$3',
  paddingRight: '$3',
  '@bp2': {
    fontSize: '$h1',
    textWrap: 'normal',
  },
})

export const HeroVideoContainer = styled('div', {
  width: '100%',
  '@bp2': {
    backgroundColor: '#D3C59A',
    padding: '1.875rem 1.75rem 0rem 1.75rem',
    borderRadius: '20px',
  },
})

export const HeroVideo = styled('div', {
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%',
  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
})

export const HeroVideoSubtitle = styled('p', {
  paddingBottom: '1.625rem',
  textAlign: 'center',
  paddingTop: '1.625rem',
  fontSize: '$body !important',
  paddingLeft: '$3',
  paddingRight: '$3',
  textWrap: 'pretty',
  '@bp2': {
    paddingLeft: '0',
    paddingRight: '0',
  },
})
